import { Flex } from "@chakra-ui/react"
import { removeHTML } from "../../../utils"

export const TabItem = ({
  children,
  onClick,
  selected,
  index,
  id,
  content
}) => (
  <Flex
    id={`${id}-tab-${index}`}
    className="TabItem"
    as="button"
    justifyContent="space-between"
    flexGrow={1}
    bgColor={selected ? "white" : "#f5f5f5"}
    position="relative"
    padding="20px 30px"
    textAlign="center"
    whiteSpace="nowrap"
    borderRight="1px solid rgba(0, 0, 0, 0.1)"
    cursor="pointer"
    onClick={(e) => {
      e.preventDefault()
      onClick()
    }}
    onKeyDown={(e) => {
      if (e.key === " " || e.key === "Enter") {
        onClick()
      }
    }}
    role="tab"
    aria-description={removeHTML(content)}
    aria-selected={selected ? "true" : "false"}
    aria-controls={`${id}-panel-${index}`}
    tabIndex={0}
  >
    {children}
  </Flex>
)
